import { toast } from "react-toastify";
import { getJwtToken, setJwtToken } from "../app/services/auth.service";
import { dayjs, qs } from "dayjs";
import { GetAccessTokenByRefreshToken } from "../app/services/security.service";
import { showToastMessage } from "../app/utility/toastHelper";
import { ApiResultModel } from "../app/models/common.model";
import { CheckOtpResponse } from "../app/models/security.model";
export default function setupAxios(axios, history) {
  const backGroundService = [
    "GetCartableNotification",
    "GetSupplierNoticeSummary",
    "GetCartSummary",
    "SearchProducts",
    "GetProductPriceInfo",
    "GetPaymentRequestExcelInfo",
    "GetCurrentNotices",
    "GetWalletInfo",
    "GetFinancialSuppliersByLoanTemplateAndOrganization",
    "GetRegistrationDuration",
  ];
  const refreshAccessToken = async () => {
    const refToken = getJwtToken().refToken;

    try {
      const response = await GetAccessTokenByRefreshToken({
        refreshToken: refToken,
      });
      const data = response;
      if (data) {
        setJwtToken(data.jwt, data.refreshToken);
        // axios.defaults.headers.common["Authorization"] =
        //   "Bearer " + data.data.jwt;
        axios.defaults.headers.common.Authorization = `Bearer ${
          getJwtToken().token
        }`;
        window.location.reload();
      } else {
        window.location.href = "/";

        setJwtToken("", "");
      }
    } catch (err) {
      window.location.href = "/";
      setJwtToken("", "");
    }
  };
  axios.interceptors.request.use(
    (config) => {
      //check jwt validation
      const configServiceUrl = config.url?.split("/");
      let serviceName =
        configServiceUrl != undefined
          ? configServiceUrl[configServiceUrl.length - 1]
          : "";
      const resultBackGroundService = backGroundService.includes(serviceName);

      if (!resultBackGroundService) {
        document.body.getElementsByClassName(
          "MuiBackdrop-root"
        )[0].hidden = false;
      }
      if (getJwtToken().token) {
        config.headers.Authorization = `Bearer ${getJwtToken().token}`;
      }

      config.paramsSerializer = (params) =>
        qs.stringify(params, {
          serializeDate: (date) => dayjs(date).format("YYYY-MM-DDTHH:mm:ssZ"),
        });

      return config;
    },

    (err) => {
      document.body.getElementsByClassName("MuiBackdrop-root")[0].hidden = true;
      Promise.reject(err);
    }
  );

  axios.interceptors.response.use(
    function(response) {
      // spinning hide
      // UPDATE: Add this code to hide global loading indicator
      const urlSplitted = response.config.url.split("/");
      const serviceName = urlSplitted[urlSplitted.length - 1];
      const { data } = response;
      if (
        serviceName == "ExportLoansForSettlement" ||
        serviceName == "ExportGetRegisterLoans" ||
        serviceName == "ExportLoans"
      ) {
        document.body.getElementsByClassName(
          "MuiBackdrop-root"
        )[0].hidden = true;
        return data;
      }

      if (!data.isSuccess) {
        let messageErr = [];
        let toastType;
        if (data.messages !== undefined || data?.messages?.length > 0) {
          data.messages.map((message) => {
            messageErr.push(message.message);
            switch (message.messageKind) {
              case 1:
                toastType = "info";
                break;
              case 2:
                toastType = "warning";
                break;
              case 3:
              case 4:
              case 5:
                toastType = "error";
                break;

              default:
                toastType = "error";
                break;
            }
          });
        }
        if (window.location.hash !== "#/otp" && messageErr.length > 0) {
          messageErr = messageErr.join("\r\n");

          // const showToast = (msg, { autoClose, type }) => {
          //   toast[type](msg, {
          //     autoClose: autoClose > 0 ? autoClose : false,
          //     closeButton: true,
          //     className: "newLineToast",
          //   });
          // };
          // showToast(messageErr, {
          //   autoClose: data.autoClose > 0 ? data.autoClose : false,
          //   toastType,
          // });
          toast.error(messageErr, {
            autoClose: data.autoClose > 0 ? data.autoClose : false,
            closeButton: true,
            className: "newLineToast",
          });
        }
      }
      const resultBackGroundService = backGroundService.includes(serviceName);

      if (!resultBackGroundService) {
        document.body.getElementsByClassName(
          "MuiBackdrop-root"
        )[0].hidden = true;
      }
      return response;
    },
    function(error) {
      const urlSplitted = error.response.config?.url?.split("/");
      let serviceName = "";
      if (urlSplitted != undefined) {
        serviceName = urlSplitted[urlSplitted.length - 1];
      }

      if (getJwtToken().token != "" && error.response?.status !== 401) {
        toast.error("مشکل در اجرای برنامه");
      }
      const resultBackGroundService = backGroundService.includes(serviceName);

      // if (error.response?.status === 401 && !resultBackGroundService) {
      if (error.response?.status === 401) {
        if (error.response.config.headers.Authorization) {
          if (getJwtToken().token != "") {
            // toast.error(
            //   "مدت زمان استفاده شما از سیستم به پایان رسیده است. لطفا  مجدد وارد شوید"
            // );
            // error.response.config.headers.Authorization = "";
            try {
              refreshAccessToken();
            } catch (error) {
              toast.error(
                "مدت زمان استفاده شما از سیستم به پایان رسیده است. لطفا  مجدد وارد شوید"
              );
              error.response.config.headers.Authorization = "";
              window.location = "#/login";
              setJwtToken("", "");
              localStorage.clear();
              sessionStorage.clear();
              window.getUserIdGoftino();
            }
          }
        }
      }
      //new config
      else if (error.response?.status === 403) {
        const errorMessage =
          error.response?.data?.messages || "دسترسی شما مجاز نیست.";
        const autoClose = error.response?.data.autoClose;
        showToastMessage(errorMessage, autoClose);
      } else if (error.response?.status === 429) {
        const errorMessage =
          error.response?.data?.messages ||
          "تعداد درخواست‌های شما بیش از حد مجاز است، لطفا بعداً تلاش کنید.";
        const autoClose = error.response?.data.autoClose;
        showToastMessage(errorMessage, autoClose);
      }
      //new config

      document.body.getElementsByClassName("MuiBackdrop-root")[0].hidden = true;
      return Promise.reject(error);
    }
  );
}
